export default "__VITE_ASSET__4b431cbd__"